import { useParams } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  Content,
  Tile,
} from "carbon-components-react";

import { BabyUnusualRecordTable } from ".";

export const BabyUnusualRecord = () => {
  const { bid } = useParams();

  return (
    <Content>
      <Breadcrumb>
        <BreadcrumbItem href="/care">護理管理</BreadcrumbItem>
        <BreadcrumbItem href={`/care/${bid}`}>新生兒護理明細</BreadcrumbItem>

        <BreadcrumbItem href="" isCurrentPage>
          新生兒異常紀錄
        </BreadcrumbItem>
      </Breadcrumb>

      <Tile>新生兒異常紀錄</Tile>

      <BabyUnusualRecordTable showWithBaby={false} />
    </Content>
  );
};
